/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FullPatientCalendarEvents = {
    type: 'array',
    contains: {
        type: 'FullPatientCalendar',
    },
};